import styled from '@emotion/styled';
import { mainColors } from 'src/assets/colors';

export const GamstopPreviouslyPositiveWrapper = styled('div', { label: 'GamstopPreviouslyPositiveWrapper' })`
    display: flex;
    flex-direction: column;
    gap: 24px;
    font-family: var(--font-family-primary);
`;

export const GamstopPreviouslyPositiveDescription = styled('p', { label: 'GamstopPreviouslyPositiveDescription' })`
    margin: 0;
    font-size: 14px;
    line-height: 1.43;
    color: ${mainColors.grays.gray500};
`;

export const GamstopPreviouslyPositiveSection = styled('section', { label: 'GamstopPreviouslyPositiveSection' })`
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 20px;
    border: 1px solid ${mainColors.grays.gray200};
    border-radius: 8px;
    background-color: ${mainColors.default.light};
`;

export const GamstopPreviouslyPositiveSectionTitle = styled('h3', { label: 'GamstopPreviouslyPositiveSectionTitle' })`
    margin: 0;
    font-size: 14px;
    font-weight: 600;
    line-height: 1.43;
    color: ${mainColors.main.primary};
`;

export const GamstopPreviouslyPositiveOptions = styled('div', { label: 'GamstopPreviouslyPositiveOptions' })`
    display: flex;
    flex-direction: column;
    gap: 12px;
`;

export const GamstopPreviouslyPositiveActions = styled('div', { label: 'GamstopPreviouslyPositiveActions' })`
    display: flex;
    justify-content: flex-start;
`;

export const GamstopPreviouslyPositiveTestTriggerField = styled('div', { label: 'GamstopPreviouslyPositiveTestTriggerField' })`
    display: flex;
    flex-direction: column;
    gap: 8px;
    max-width: 320px;
`;

export const GamstopPreviouslyPositiveTestTriggerLabel = styled('label', { label: 'GamstopPreviouslyPositiveTestTriggerLabel' })`
    font-size: 14px;
    font-weight: 500;
    line-height: 1.43;
    color: ${mainColors.main.primary};
`;

export const GamstopPreviouslyPositiveTestTriggerInput = styled('input', { label: 'GamstopPreviouslyPositiveTestTriggerInput' })`
    width: 100%;
    padding: 8px 12px;
    border: 1px solid ${mainColors.grays.gray200};
    border-radius: 6px;
    font-size: 14px;
    line-height: 1.43;
    color: ${mainColors.main.primary};
    background-color: ${mainColors.default.light};

    &:focus {
        outline: none;
        border-color: ${mainColors.grays.gray400};
    }
`;

export const GamstopPreviouslyPositiveTestTriggerActions = styled('div', { label: 'GamstopPreviouslyPositiveTestTriggerActions' })`
    display: flex;
    justify-content: flex-start;
`;

export const GamstopPreviouslyPositiveCommunicationChannelWrapper = styled('div', { label: 'GamstopPreviouslyPositiveCommunicationChannelWrapper' })<{ $isVisible: boolean }>`
    display: grid;
    grid-template-rows: ${({ $isVisible }): string => ($isVisible ? '1fr' : '0fr')};
    margin: -4px 0 0;
    transition: grid-template-rows 0.3s ease;
`;

export const GamstopPreviouslyPositiveCommunicationChannelInner = styled('div', { label: 'GamstopPreviouslyPositiveCommunicationChannelInner' })`
    overflow: hidden;
    min-height: 0;
`;

export const GamstopPreviouslyPositiveCommunicationChannelSection = styled('section', { label: 'GamstopPreviouslyPositiveCommunicationChannelSection' })`
    display: flex;
    flex-direction: column;
    gap: 12px;
    padding: 16px 20px;
    border: 1px solid ${mainColors.status.success};
    border-radius: 8px;
    background-color: rgba(16, 185, 129, 0.08);
`;

export const GamstopPreviouslyPositiveCommunicationChannelTitle = styled('h3', { label: 'GamstopPreviouslyPositiveCommunicationChannelTitle' })`
    margin: 0;
    font-size: 14px;
    font-weight: 600;
    line-height: 1.43;
    color: ${mainColors.status.success};
`;

export const GamstopPreviouslyPositiveCommunicationChannelDescription = styled('p', { label: 'GamstopPreviouslyPositiveCommunicationChannelDescription' })`
    margin: 0;
    font-size: 13px;
    line-height: 1.38;
    color: ${mainColors.grays.gray500};
`;

export const GamstopPreviouslyPositiveCommunicationChannelOptions = styled('div', { label: 'GamstopPreviouslyPositiveCommunicationChannelOptions' })`
    display: flex;
    flex-direction: column;
    gap: 12px;
`;

export const GamstopPreviouslyPositiveCommunicationChannelOption = styled('label', { label: 'GamstopPreviouslyPositiveCommunicationChannelOption' })`
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 14px;
    line-height: 1.43;
    color: ${mainColors.main.primary};
    cursor: pointer;
`;

export const GamstopPreviouslyPositiveCommunicationOnlyPanelWrapper = styled('div', { label: 'GamstopPreviouslyPositiveCommunicationOnlyPanelWrapper' })<{ $isVisible: boolean }>`
    display: grid;
    grid-template-rows: ${({ $isVisible }): string => ($isVisible ? '1fr' : '0fr')};
    margin: -4px 0 0;
    transition: grid-template-rows 0.3s ease;
`;

export const GamstopPreviouslyPositiveCommunicationOnlyPanelInner = styled('div', { label: 'GamstopPreviouslyPositiveCommunicationOnlyPanelInner' })`
    overflow: hidden;
    min-height: 0;
`;

export const GamstopPreviouslyPositiveCommunicationOnlyPanelSection = styled('div', { label: 'GamstopPreviouslyPositiveCommunicationOnlyPanelSection' })`
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding: 12px 16px;
    border: 1px solid ${mainColors.grays.gray200};
    border-radius: 8px;
    background-color: ${mainColors.grays.gray100};
`;

export const GamstopPreviouslyPositiveCommunicationOnlyPanelField = styled('div', { label: 'GamstopPreviouslyPositiveCommunicationOnlyPanelField' })`
    display: flex;
    flex-direction: column;
    gap: 4px;
    width: 100%;
    max-width: 320px;

    > div {
        margin-bottom: 0;
    }
`;

